export default () => ({
	list: [],
	detail: {}
})
